import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import ScrollToTop from './components/ScrollToTop';
import { ModalProvider } from './context/ModalContext';
import { ApplyProvider } from './context/ApplyContext';
import GlobalApplyModal from './components/GlobalApplyModal';
import FundingSathiModal from './components/FundingSathiModal';

// Pages
import HomePageExact from './pages/HomePageExact';
import AboutPage from './pages/AboutPage';
import ServicesPage from './pages/ServicesPage';
import CareersPage from './pages/CareersPage';
import ContactPage from './pages/ContactPage';
import TermsPage from './pages/TermsPage';
import PrivacyPage from './pages/PrivacyPage';
import RiskDisclosurePage from './pages/RiskDisclosurePage';
import UploadsPage from './pages/UploadsPage';

function App() {
  return (
    <ModalProvider>
      <ApplyProvider>
      <Router>
        <ScrollToTop />
        <div className="min-h-screen bg-[#FAFAFA] overflow-x-hidden">
          <Routes>
            <Route path="/" element={<HomePageExact />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/services" element={<ServicesPage />} />
            <Route path="/careers" element={<CareersPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/terms" element={<TermsPage />} />
            <Route path="/privacy" element={<PrivacyPage />} />
            <Route path="/risk-disclosure" element={<RiskDisclosurePage />} />
            <Route path="/admin/uploads" element={<UploadsPage />} />
          </Routes>
        </div>
        </Router>
        <FundingSathiModal />
        <GlobalApplyModal />
      </ApplyProvider>
    </ModalProvider>
  );
}

export default App;
